module.exports = __webpack_public_path__ + "static/BentonSansExtraComp-Book-90289512af367b809449e824e000e3be.woff";